module.exports = __webpack_public_path__ + "img/intro-2.cf93a077.png";